// extracted by mini-css-extract-plugin
export default {"content":"intro_content__O+gTZ","title":"intro_title__7MRzl","tac":"intro_tac__2idC7"};